import UserDashboardPage from "../pages/authPages/userDashboardPage";
import SignInPage from "../pages/noAuthPages/signIn";
import SignUpPage from "../pages/noAuthPages/signUp";
import ConfirmationPage from "../pages/noAuthPages/confirmation";
import ForgotPasswordPage from "../pages/noAuthPages/forgotPassword";
import ResetPasswordPage from "../pages/noAuthPages/resetPassword";
import LinkExpiredPage from "../pages/noAuthPages/LinkExpiredPage";
import UserRoute from "../protectedRoute/userRoute";
import UserLayout from "../components/userLayout/userLayout";
import SideBar from "../components/sideBar/sideBar";
import UserSetting from "../pages/authPages/userSetting";
import UserSATPracticePage from "../pages/authPages/userSATPracticePage";
import UserPracticeScreen from "../pages/authPages/userPracticeScreen";
import UserFullTestScreen from "../pages/authPages/userFullTestScreen";
import UserPackageSelectionPage from "../pages/authPages/userPackageSelectionPage";
import CheckoutPage from "../pages/authPages/checkoutPage";
import PricingPage from "../pages/noAuthPages/pricing";
import AboutUsPage from "../pages/noAuthPages/aboutUs";
import TermsOfServicePage from "../pages/noAuthPages/termsOfService";
import PrivacyPolicyPage from "../pages/noAuthPages/privacyPolicy";
import RefundComplaintPolicyPage from "../pages/noAuthPages/refundComplaintPolicy";
import { Navigate } from "react-router-dom";
import LandingPage from "../pages/noAuthPages/landingPage";

const IS_DEMO = process.env.REACT_APP_ENVCONFIG === "demo";

// Root path handler component that checks for confirmation and reset password hash parameters
const RootPathHandler = () => {
  const hash = window.location.hash;
  const search = window.location.search;

  // Check for error parameters in hash or search (expired/invalid links)
  const hasError = (hash && hash.includes('error')) || (search && search.includes('error'));
  if (hasError) {
    const params = hash || search;
    window.location.href = `/link-expired${params}`;
    return null;
  }

  //TODO
  if (hash && hash.includes('type=signup')) {
    window.location.href = `/confirmation${hash}`;
    return null;
  }

  if (hash && (hash.includes('type=recovery'))) {
    window.location.href = `/reset-password${hash}`;
    return null;
  }

  // Demo env: skip landing page and go directly to the dashboard
  if (IS_DEMO) {
    return <Navigate to="/user-dashboard" replace />;
  }

  // Default: redirect to landing page
  return <Navigate to="/landing" replace />;
};

export const allRoutes = [
  {
    path: "/",
    element: <RootPathHandler />
  },
  {
    path: "landing",
    element: <LandingPage />
  },
  {
    path: "/sign-in",
    element: <SignInPage />

  },
  {
    path: "/sign-up",
    element: <SignUpPage />

  },
  {
    path: "/confirmation",
    element: <ConfirmationPage />
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />
  },
  {
    path: "/link-expired",
    element: <LinkExpiredPage />
  },
  {
    path: "/pricing",
    element: <PricingPage />
  },
  {
    path: "/about-us",
    element: <AboutUsPage />
  },
  {
    path: "/terms-of-service",
    element: <TermsOfServicePage />
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />
  },
  {
    path: "/refund-complaint-policy",
    element: <RefundComplaintPolicyPage />
  },
  {
    path: "/user-dashboard",
    element:
      <UserRoute>
        <UserLayout>
          <SideBar />
          <UserDashboardPage />
        </UserLayout>
      </UserRoute>
  },
  {
    path: "*",
    element:
      <LinkExpiredPage />
  },
  {
    path: "/user-setting",
    element:
      <UserRoute>
        <UserLayout>
          <SideBar />
          <UserSetting />
        </UserLayout>
      </UserRoute>
  },
  {
    path: "/user-sat-practice",
    element:
      <UserRoute>
        <UserLayout>
          <SideBar />
          <UserSATPracticePage />
        </UserLayout>
      </UserRoute>
  },
  {
    path: "/user-practice-session",
    element:
      <UserRoute>
        <UserPracticeScreen />
      </UserRoute>
  },
  {
    path: "/user-full-test/:examinationId",
    element:
      <UserRoute>
        <UserLayout>
          <SideBar />
          <UserFullTestScreen />
        </UserLayout>
      </UserRoute>
  },
  {
    path: "/user-package",
    element:
      <UserRoute>
        <UserLayout>
          <SideBar />
          <UserPackageSelectionPage />
        </UserLayout>
      </UserRoute>
  },
  {
    path: "/user-checkout",
    element:
      <UserRoute>
        <CheckoutPage />
      </UserRoute>
  }
];

export default allRoutes;
